import { Link } from '@ecm/router';

import { AbstractContractItemViewModel } from '../abstract-contract.view-model';

export class MultiContractViewModel extends AbstractContractItemViewModel {
    public messages?: string[];
    public button?: string;
    public linkInternet?: Link;
    public eSimLabel?: string;
    public eSimLink?: Link;
}
